import { FC } from "react";

import { ZoomToFitIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

import MapMenuItemControl from "../menuItemControl";

type Props = {
  onToggle: () => void;
  /** Callers that never leave the inline layout can leave this alone. */
  isFullScreen?: boolean;
  className?: string;
};

const MapFullScreenControl: FC<Props> = ({
  onToggle,
  isFullScreen = false,
  className
}) => {
  const label = isFullScreen ? "Exit full screen" : "View in full screen";

  return (
    <MapMenuItemControl
      className={twMerge("rounded-lg border-[1px] border-gainsboro", className)}
      onClick={onToggle}
      aria-label={label}
      tooltipContent={`${label}.`}
    >
      <ZoomToFitIcon className="fill-dim-gray" />
    </MapMenuItemControl>
  );
};

export default MapFullScreenControl;
